import { resolvePublishDate } from '@/utils/publishDate';

interface LastUpdatedProps {
  builderState?: any;
}

/**
 * Placement-only component. Date value comes from page model field `lastUpdatedAt`.
 */
export default function LastUpdated({ builderState }: LastUpdatedProps) {
  const content = builderState?.content;
  const { displayText } = resolvePublishDate(content?.data?.lastUpdatedAt, content?.lastUpdated);

  if (!displayText) {
    return null;
  }

  return (
    <p className="tw-text-[12px] tw-font-book tw-text-gray-500 tw-text-center tw-mt-[-40px] tw-mb-4 lg:tw-mb-10 tw-mx-auto">
      Updated: {displayText}
    </p>
  );
}
